export function createBiLoggerWithDefaults(params) {
  return typeof params.biLoggerOrFactory === 'function' ? params.biLoggerOrFactory().logger() : params.biLoggerOrFactory;
}
//# sourceMappingURL=createBiLoggerWithDefaults.js.map